import { render, staticRenderFns } from "./PopoverRosterProgramEligiblePatients.vue?vue&type=template&id=546e8947&scoped=true"
import script from "./PopoverRosterProgramEligiblePatients.vue?vue&type=script&lang=js"
export * from "./PopoverRosterProgramEligiblePatients.vue?vue&type=script&lang=js"
import style0 from "./PopoverRosterProgramEligiblePatients.vue?vue&type=style&index=0&id=546e8947&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546e8947",
  null
  
)

export default component.exports